__turbopack_context__.v({
  "className": "jetbrains_mono_4d9baa28-module__IwmL_a__className",
  "variable": "jetbrains_mono_4d9baa28-module__IwmL_a__variable",
});
